const InvoiceChannel = `
  id
  description
  updatedAt
  sagecode
`;

export default InvoiceChannel;
